import { render, staticRenderFns } from "./HomeWel.vue?vue&type=template&id=8f4890e4&scoped=true"
import script from "./HomeWel.vue?vue&type=script&lang=js"
export * from "./HomeWel.vue?vue&type=script&lang=js"
import style0 from "./HomeWel.vue?vue&type=style&index=0&id=8f4890e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4890e4",
  null
  
)

export default component.exports